import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Pagination } from '@totalsoft/rocket-ui';

const PaginationWrapper = ({ page, ...rest }) => {
  const { t } = useTranslation();

  return <Pagination rowsPerPageText={t('RowsPerPage')} rowsOfText={t('RowsOf')} page={page - 1} {...rest} />;
};

PaginationWrapper.propTypes = {
  page: PropTypes.number
};

export default PaginationWrapper;
